import useWeakMap from "../../utils/useWeakMap";
import useStoreMonitor from "../../warehouse/useStoreMonitor";
import { lookupChildNodes } from "../util";

const store = useWeakMap();

const useMarkIsCustomComponent = (node) => {
    const allChildNodes = lookupChildNodes(node);
    store.set(node, allChildNodes);

    for (let i = 0, len = allChildNodes.length; i < len; i++) {
        const item = allChildNodes[i];
        store.set(item, null);
    }
}

export const removeMarkCustomComponent = (node) => {
    if (!store.has(node)) return;
    const childs = store.get(node)
    while (childs.length > 0) {
        const item = childs.shift();
        store.delete(item);
    }
    store.delete(node);
}

export const checkIsCustomComponent = (node) => {
    return store.has(node);
}

export default useMarkIsCustomComponent;